import { z } from 'zod';

const emailField = z
    .string()
    .min(1, 'Email is required')
    .email('Enter a valid email address');

const passwordField = z
    .string()
    .min(1, 'Password is required')
    .min(6, 'Password must be at least 6 characters');

const mobileField = z
    .string()
    .min(1, 'Mobile number is required')
    .regex(/^\d{10,14}$/, 'Enter a valid mobile number (10-14 digits)');

const nameField = (label) =>
    z.string().min(1, `${label} is required`).min(2, `${label} must be at least 2 characters`);


export const loginSchema = z.object({
    email: emailField,
    password: passwordField,
});

export const registerSchema = z
    .object({
        fname: nameField('First name'),
        lname: nameField('Last name'),
        mobile: mobileField,
        email: emailField,
        password: passwordField,
        confirmPassword: z.string().min(1, 'Please confirm your password'),
        rc: z.string().optional(),
        isAccepted: z.boolean().refine((val) => val === true, {
            message: 'You must accept the terms and privacy policy',
        }),
    })
    .refine((data) => data.password === data.confirmPassword, {
        message: 'Passwords do not match',
        path: ['confirmPassword'],
    });
    
export const googleRegisterSchema = z.object({
    fname: nameField('First name'),
    lname: nameField('Last name'),
    mobile: z.string().min(1, 'WhatsApp number is required'),
    isAccepted: z.boolean().refine((val) => val === true, {
        message: 'You must accept the terms and privacy policy',
    }),
});

export const forgotPasswordSchema = z.object({
    email: emailField,
});

export const resetPasswordSchema = z
    .object({
        password: passwordField,
        confirmPassword: z.string().min(1, 'Please confirm your password'),
    })
    .refine((data) => data.password === data.confirmPassword, {
        message: 'Passwords do not match',
        path: ['confirmPassword'],
    });